export default function textRotor(el) {
  const bullets = el.querySelectorAll("p");
  let lines = Array.prototype.slice.call(bullets).map(x => x.innerText);

  for (let i = lines.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [lines[i], lines[j]] = [lines[j], lines[i]];
  }

  new typeWriter(el, lines, 2000, "…", true);
}

const typeWriter = function(el, lines, delay, cursor) {
  el.innerHTML = "";

  this.el = el;
  this.lines = lines;
  this.delay = delay;
  this.cursor = cursor;
  this.loopIteration = 0;
  this.displayText = "";
  this.isDeleting = false;

  // And off we go
  this.tick();
};

typeWriter.prototype.tick = function() {
  let i = this.loopIteration % this.lines.length;
  let charDisplayTime = 150 - Math.random() * 100;
  const fullLine = this.lines[i];

  if (this.isDeleting) {
    this.displayText = fullLine.substring(0, this.displayText.length - 1);
  } else {
    this.displayText = fullLine.substring(0, this.displayText.length + 1);
  }

  this.el.innerText = this.displayText + this.cursor;

  // Speed up deleting text
  if (this.isDeleting) {
    charDisplayTime /= 2;
  }

  if (!this.isDeleting && this.displayText === fullLine) {
    // Show the last line longer
    if (this.loopIteration == this.lines.length - 1) {
      charDisplayTime = this.delay * 4;
    } else {
      charDisplayTime = this.delay;
    }
    this.isDeleting = true;
  } else if (this.isDeleting && this.displayText === "") {
    this.isDeleting = false;
    this.loopIteration++;
    charDisplayTime = 500; // Pause before adding new text
  }

  const $this = this;
  setTimeout(function() {
    $this.tick();
  }, charDisplayTime);
};
